// Detects the "MAINTENANCE" error contract that /v1/b2c/cabins returns when a
// cruise line is temporarily under maintenance on the backend (PHP) side.
//
// The upstream PHP response is a 422 with:
//   { message, errors: { errorCode: ["MAINTENANCE"], errorDescription: ["..."] } }
//
// b2b-backend re-throws this unchanged, but nests it under `status.description`
// (see b2b-backend src/b2c/b2c.service.ts findCabins), so the axios error seen
// here has the shape:
//   error.response.data === { status: { code: 422, description: { errors: { ... } } } }
export function extractCabinsMaintenanceInfo(error) {
  const status = error?.response?.status;
  const errors = error?.response?.data?.status?.description?.errors;

  if (status === 422 && Array.isArray(errors?.errorCode) && errors.errorCode.includes("MAINTENANCE")) {
    return {
      isMaintenance: true,
      message: errors.errorDescription?.[0],
    };
  }

  return { isMaintenance: false };
}
